export enum CheckoutState {
  OPEN = 0,
  PENDING = 1,
  DONE = 2,
  ERROR = 3,
  FINALIZING = 4,
}

export enum CheckoutDeliveryState {
  INITIAL = 0,
  ADDRESS_CHOSEN = 1,
  DATE_CHOSEN = 2,
  FINAL = 3,
}
